import { Link } from 'react-router-dom';

/**
 * Política de Privacidade — página PÚBLICA, sem login.
 *
 * Fica fora de qualquer rota protegida de propósito: é o endereço exigido no
 * cadastro de apps da OpenAI e em qualquer integração que peça política
 * publicada. Se passar a exigir sessão, a submissão quebra.
 *
 * O conteúdo saiu do modelo de dados real (rum-session, session-recording, log,
 * error-occurrence, host, user), não de modelo pronto. O que define este
 * documento é que a plataforma observa o VISITANTE DO CLIENTE: IP, user agent,
 * latitude/longitude, cidade, dispositivo, navegador e — quando o cliente ativa
 * — a gravação da sessão. Por isso a divisão de papéis vem antes de tudo.
 */
const SECOES: Array<{ id: string; n: string; titulo: string; itens: string[] }> = [
  {
    id: 'papeis',
    n: '1',
    titulo: 'Quem responde por quê',
    itens: [
      'A KUBMIX INTELIGÊNCIA EM CLOUD PROVIDER LTDA. (CNPJ 48.369.363/0001-25) é CONTROLADORA dos dados de cadastro, cobrança, suporte e segurança da conta do CLIENTE que contrata a plataforma.',
      'A KUBMIX é OPERADORA dos dados de telemetria que a plataforma coleta das aplicações, servidores e usuários finais do CLIENTE. Esses dados são do CLIENTE, que é a controladora deles e quem define o que instrumentar, o que mascarar e por quanto tempo reter.',
      'É responsabilidade do CLIENTE informar os próprios usuários finais sobre a coleta, obter a base legal aplicável (inclusive o consentimento, quando for o caso) e configurar o nível de privacidade das gravações de sessão.',
      'A KUBMIX não utiliza a telemetria do CLIENTE para finalidade própria, não a comercializa e não a usa para treinar modelos de inteligência artificial.',
    ],
  },
  {
    id: 'dados-cliente',
    n: '2',
    titulo: 'Dados do CLIENTE (onde somos controladora)',
    itens: [
      'Cadastro: nome, sobrenome, e-mail, foto de perfil, situação da conta, data do último acesso e papéis atribuídos.',
      'Autenticação: resumo criptográfico (hash) da senha. A senha em si não é armazenada nem recuperável.',
      'Organização: identificação do tenant, aplicações cadastradas, plano, assinatura, faturas, pagamentos e registros de uso para faturamento.',
      'Programa de afiliados, quando aplicável: indicações e comissões.',
      'Suporte e comunicação operacional: chamados, destinatários de alerta e assinantes de página de status.',
    ],
  },
  {
    id: 'dados-telemetria',
    n: '3',
    titulo: 'Dados de telemetria (onde somos operadora)',
    itens: [
      'Monitoramento de usuário real (RUM): identificador de sessão, identificador de usuário ou identificador anônimo definidos pelo CLIENTE, plataforma, tipo e modelo do dispositivo, sistema operacional e versão, navegador e versão, resolução de tela e viewport, país, cidade, LATITUDE e LONGITUDE aproximadas, ENDEREÇO IP, user agent, duração da sessão e contagem de páginas, eventos e erros.',
      'Gravação de sessão, somente quando o CLIENTE a ativa: reprodução da navegação do usuário final, com nível de privacidade e indicação de consentimento definidos pelo CLIENTE na instrumentação.',
      'Erros e exceções: mensagem, pilha de chamadas, versão da aplicação e contexto enviado pela aplicação do CLIENTE.',
      'Logs: mensagem, severidade, atributos, atributos de recurso, host e origem, além de identificadores de trace e span.',
      'Rastreamento distribuído e desempenho (APM): traces, spans, serviços, consultas lentas e conexões entre serviços.',
      'Infraestrutura: métricas de host, processos em execução, contêineres, recursos de nuvem, clusters, nós, pods e eventos de Kubernetes, bancos monitorados e logs de firewall.',
      'Mobile: sessões, travamentos (crash) e ANR.',
      'Disponibilidade e varreduras: monitores de uptime, varreduras de segurança e de SEO sobre os endereços que o CLIENTE cadastrar.',
      'IMPORTANTE: o conteúdo desses dados depende inteiramente de como o CLIENTE instrumenta a própria aplicação. Se a aplicação envia dado pessoal em log, atributo ou mensagem de erro, esse dado chega à plataforma. Cabe ao CLIENTE evitar enviar o que não precisa e usar os recursos de mascaramento.',
    ],
  },
  {
    id: 'finalidades',
    n: '4',
    titulo: 'Para que usamos',
    itens: [
      'Execução do contrato: receber, armazenar, processar e exibir a telemetria; gerar alertas, incidentes, painéis e relatórios; manter a conta e processar pagamentos.',
      'Obrigação legal: emissão de documentos fiscais e guarda de registros de acesso na forma do Marco Civil da Internet.',
      'Legítimo interesse, limitado ao necessário: segurança da plataforma, prevenção a abuso, dimensionamento de capacidade e melhoria do produto.',
      'A KUBMIX não comercializa dados pessoais e não os utiliza para publicidade de terceiros.',
    ],
  },
  {
    id: 'compartilhamento',
    n: '5',
    titulo: 'Com quem compartilhamos',
    itens: [
      'Processamento de pagamento: Stripe, Inc.',
      'Envio de notificação de alerta pelos canais que o próprio CLIENTE configurar, como e-mail, mensageria e integrações externas.',
      'Provedores de inteligência artificial, quando o CLIENTE aciona recursos de análise assistida — apenas o conteúdo submetido naquela interação.',
      'Autoridade pública, exclusivamente mediante requisição fundamentada e nos limites da lei.',
      'Alguns operadores estão sediados fora do Brasil; a transferência observa o art. 33 da LGPD, com cláusulas contratuais e salvaguardas equivalentes.',
    ],
  },
  {
    id: 'retencao',
    n: '6',
    titulo: 'Por quanto tempo guardamos',
    itens: [
      'Telemetria: pelo período de retenção do plano contratado ou pelo prazo que o CLIENTE configurar, o que for menor. Encerrado o prazo, os dados são descartados.',
      'Gravações de sessão: pelo prazo configurado pelo CLIENTE; podem ser apagadas por ele a qualquer momento.',
      'Cadastro e cobrança: enquanto a conta estiver ativa e, depois, pelo prazo das obrigações legais e fiscais.',
      'Registros de acesso à aplicação: no mínimo 6 (seis) meses, conforme o art. 15 da Lei nº 12.965/2014.',
    ],
  },
  {
    id: 'direitos',
    n: '7',
    titulo: 'Direitos do titular',
    itens: [
      'Confirmação de tratamento, acesso, correção, anonimização, bloqueio ou eliminação, portabilidade, informação sobre compartilhamento e revogação do consentimento, nos termos do art. 18 da LGPD.',
      'Usuário final de uma aplicação monitorada deve dirigir seu pedido ao CLIENTE dono daquela aplicação, que é a controladora da telemetria. A KUBMIX apoia o CLIENTE no atendimento, inclusive na localização e eliminação dos registros.',
      'Titular que seja usuário da própria plataforma exerce seus direitos pelos canais indicados abaixo.',
    ],
  },
  {
    id: 'seguranca',
    n: '8',
    titulo: 'Segurança',
    itens: [
      'Criptografia em trânsito (TLS), senhas armazenadas apenas como hash, controle de acesso por papéis e permissões e isolamento por tenant em todas as consultas.',
      'A ingestão de telemetria é autenticada por chave da aplicação, emitida e revogável pelo CLIENTE.',
      'Em incidente de segurança com risco relevante, a KUBMIX comunicará a Autoridade Nacional de Proteção de Dados e, conforme o caso, o CLIENTE e os titulares afetados, na forma do art. 48 da LGPD.',
    ],
  },
  {
    id: 'contato',
    n: '9',
    titulo: 'Alterações e contato',
    itens: [
      'Esta Política pode ser atualizada para refletir mudanças no produto ou na legislação; alterações relevantes são comunicadas com antecedência razoável.',
      'Dúvidas, pedidos de titular e comunicação de incidente: canal de suporte no painel ou contato@kubmix.com.',
      'Os dados de contato do Encarregado pelo Tratamento de Dados Pessoais (DPO) estão disponíveis mediante solicitação pelos canais acima.',
    ],
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-gray-100">
      <header className="sticky top-0 z-30 border-b border-gray-200 bg-white/90 backdrop-blur dark:border-gray-700 dark:bg-gray-800/90">
        <div className="mx-auto flex h-14 max-w-4xl items-center justify-between px-4">
          <span className="text-lg font-semibold">Kubmix Monitor</span>
          <Link to="/login" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100">Entrar</Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-10">
        <h1 className="text-3xl font-bold tracking-tight">Política de Privacidade</h1>
        <p className="mt-2 text-sm text-gray-500">Atualizada em 2 de outubro de 2026</p>

        <div className="mt-6 space-y-3 rounded-xl border border-gray-200 bg-white p-5 text-[15px] leading-7 text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <p>
            Esta Política descreve como a KUBMIX INTELIGÊNCIA EM CLOUD PROVIDER LTDA., inscrita no CNPJ nº 48.369.363/0001-25,
            com sede na Avenida Marcos Penteado de Ulhoa Rodrigues, nº 939, 8º Andar, Torre Jacarandá, Tamboré, Barueri/SP,
            CEP 06460-040 (“KUBMIX”), trata dados pessoais na plataforma de observabilidade e monitoramento, incluindo
            monitoramento de usuário real, gravação de sessão, erros, logs, rastreamento distribuído e métricas de infraestrutura.
          </p>
          <p>Esta Política é regida pela Lei nº 13.709/2018 (LGPD).</p>
        </div>

        {SECOES.map((s) => (
          <section key={s.id} id={s.id} className="scroll-mt-20 pt-9">
            <h2 className="flex items-baseline gap-2 text-xl font-semibold tracking-tight">
              <span className="tabular-nums text-blue-600 dark:text-blue-400">{s.n}.</span>
              {s.titulo}
            </h2>
            <ul className="mt-3 space-y-2 border-l-2 border-gray-200 pl-4 dark:border-gray-700">
              {s.itens.map((it, i) => (
                <li key={i} className="text-[15px] leading-7 text-gray-600 dark:text-gray-300">{it}</li>
              ))}
            </ul>
          </section>
        ))}
      </main>

      <footer className="border-t border-gray-200 py-8 text-center text-xs text-gray-500 dark:border-gray-700">
        KUBMIX INTELIGÊNCIA EM CLOUD PROVIDER LTDA. · CNPJ 48.369.363/0001-25 · Barueri/SP
      </footer>
    </div>
  );
}
